import { Capacitor } from '@capacitor/core';
import BUILD_VERSION from '/src/utils/version';

const IS_ANDROID = Capacitor.getPlatform() === 'android'

const NODE_ENV = process.env.NODE_ENV

const ROOT_API = import.meta.env.VITE_API_URL

// Public OAuth client ids for social login (safe to expose to the browser).
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ""
const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID || ""


let PRODUUZIT_FRONT_ENV = {
    IS_ANDROID,
    BUILD_VERSION,
    NODE_ENV,
    ROOT_API,
    GOOGLE_CLIENT_ID,
    MICROSOFT_CLIENT_ID,
}

export default PRODUUZIT_FRONT_ENV
